/* ─────────────────────────────────────────────────────────────────────────────
 *  relatedSearches.ts — Related search suggestions for results page
 * ───────────────────────────────────────────────────────────────────────────── */

export interface RelatedSearch {
  query: string;
  navigateTo: string;
}

export const RELATED_SEARCHES: RelatedSearch[] = [
  { query: "jasur shukurov resume", navigateTo: "/resume" },
  { query: "jasur shukurov projects", navigateTo: "/projects" },
  { query: "software engineer portfolio", navigateTo: "/all" },
  { query: "jasur shukurov github", navigateTo: "https://github.com/jasur-2902" },
  { query: "jasur shukurov linkedin", navigateTo: "https://www.linkedin.com/in/jasurshukurov/" },
  { query: "amazon software engineer", navigateTo: "/experience" },
  { query: "jasur shukurov maps", navigateTo: "/maps" },
  { query: "contact jasur shukurov", navigateTo: "/email" },
];
